import React from 'react';

import { ColumnsSettings } from './ColumnsSettings';

interface Props {
  nodeIds: string[];
  parentId?: string;
}

export const ColumnSettings = ({ nodeIds, parentId }: Props) => {
  if (!parentId) {
    return null;
  }

  return <ColumnsSettings nodeIds={[parentId]} selectedIds={nodeIds} />;
};
